const state = {
  statistics: [
    {
      user_property_type_option_name: 'loading',
      evaluation_types: []
    }
  ]
};

const mutations = {
  STORE_RESPONSE_DATA(state, body) {
    Object.assign(state, body);
  }
};

const getters = {
  itemsCount({ statistics }) {
    if (statistics.length === 0) return 0;

    const { evaluation_types } = statistics[0];
    if (evaluation_types.length === 0) return 0;

    const counts = evaluation_types.map(evaluationType =>
      evaluationType.options.reduce((a, e) => a + e.count, 0)
    );
    return Math.max(...counts);
  }
};

const actions = {
  fetchStatistics({ commit, rootState, getters }) {
    return rootState.api
      .fetchProductStatistics(rootState.productCode, rootState.widget.widget.id)
      .then(({ data }) => {
        commit('STORE_RESPONSE_DATA', { statistics: data.statistics });
        commit(
          'widget/SET_HAS_MINIMUM_ITEMS',
          getters.itemsCount > rootState.widget.widget.min_items_count,
          {
            root: true
          }
        );
      });
  }
};

export default { namespaced: true, state, mutations, getters, actions };
